import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

const Header = () => {
  return (
    <header style={{
      background: 'var(--bg-primary)',
      borderBottom: '1px solid var(--border-light)',
      padding: '1.25rem 0',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      backdropFilter: 'blur(10px)',
      backgroundColor: 'rgba(250, 249, 246, 0.95)'
    }}>
      <div className="container">
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap'
        }}>
          {/* Logo */}
          <Link 
            to="/" 
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '1.5rem',
              fontWeight: '500',
              color: 'var(--text-primary)',
              textDecoration: 'none',
              letterSpacing: '0.05em',
              minWidth: '60px'
            }}
          >
            drs.
          </Link>

          {/* Call Button & Mobile Menu */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.5rem',
            flexShrink: 0
          }}>
            {/* Phone Button - Desktop */}
            <a
              href="tel:04-91-76-16-73"
              className="btn-call hidden md:flex"
              style={{
                padding: '0.75rem 1.5rem',
                fontSize: '0.9rem',
                minWidth: 'auto',
                whiteSpace: 'nowrap'
              }}
            >
              <Phone size={18} />
              04 91 76 16 73
            </a>

            {/* Mobile Phone Button - Compact */}
            <a
              href="tel:04-91-76-16-73"
              style={{
                background: 'var(--accent-primary)',
                color: 'var(--white)',
                border: 'none',
                borderRadius: '20px',
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                width: '40px',
                height: '40px',
                flexShrink: 0
              }}
              className="md:hidden"
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
              }}
            >
              <Phone size={20} />
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;